// extracted by mini-css-extract-plugin
export default {"gradient":"MainPage_gradient__znZnF","light":"MainPage_light__Iby2s","bl":"MainPage_bl__wt5k1"};